import { ILocation } from '@wix/yoshi-flow-editor';

export const isSledRun = (location: ILocation) => {
  const q = location.query.viewerPlatformOverrides ?? '';
  return q.includes('/sled.wix.dev/');
};
